import { CSSProperties } from 'react';
import { BoxProps, Box } from '@cad-arc';

export function EventLabelPill({
    name,
    style = {},
    variant = 'default',
}: {
    name: string;
    style?: CSSProperties;
    variant?: 'ghost' | 'default';
}): React.ReactElement {
    return (
        <Box
            h="21px"
            lineHeight="1"
            backgroundColor={variant === 'ghost' ? '' : 'var(--arc-colors-selected-accent)'}
            border={
                variant === 'ghost'
                    ? '1px dashed var(--arc-colors-text-placeholder)'
                    : `1px solid transparent`
            }
            fontWeight="400"
            padding="1px 3px"
            borderRadius={3}
            width="fit-content"
            color={
                variant === 'ghost'
                    ? 'var(--arc-colors-text-placeholder)'
                    : 'var(--arc-colors-text-primary)'
            }
            textOverflow="ellipsis"
            overflow="hidden"
            maxWidth="100%"
            display="inline-flex"
            className="event-label-pill"
            {...(style as BoxProps)}
        >
            {name}
        </Box>
    );
}
